<template>
  <div id="app">
<!--    <div id="nav">-->
<!--      <router-link to="/">首页</router-link> |-->
<!--      <router-link to="../login">登陆</router-link> |-->
<!--      <router-link to="../myMenu">返回</router-link>-->
<!--      <router-link to="../attentioncar">客户</router-link>|-->
<!--      <router-link to="../salesman">业务员</router-link>|-->
<!--      <router-link to="../setter">安装员</router-link>-->
<!--    </div>-->
      <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>
<script>
    export default {
        name: 'App',
        provide() {
            return {
                reload: this.reload
            }
        },
        data() {
            return {
                isRouterAlive: true
            }
        },
        methods: {
            reload() {
                this.isRouterAlive = false
                this.$nextTick(function () {
                    this.isRouterAlive = true
                })
            }
        },
    }
</script>
<style lang="less">
#app {
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
}
#nav {
  width: 100%;
  background-color: aliceblue;
  z-index: 9999;
  position: fixed;
  bottom: 0px;
  align-content: center;
  /*margin: 20px 20%;*/
  padding: 10px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
